module.exports = __webpack_public_path__ + "img/visa.77fd8a00.png";